import { useMutation } from 'react-query';
import { AxiosResponse } from 'axios';
import { updateCompanyInfo } from 'api/companyService';

interface CompanyInfo {
  accountManager: {
    accountManagerUuid: string;
    contact: {
      emailAddress: string;
      firstName: string;
      lastName: string;
    };
  };
  amazonTeamAccountId: string;
  companyId: number;
  companyName: string;
  platformVoice: boolean;
}

export const useUpdateCompanyInfo = () => {
  return useMutation<AxiosResponse, unknown, CompanyInfo, void>((payload) =>
    updateCompanyInfo(payload),
  );
};
